import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4 text-center" }
const _hoisted_4 = ["data-feather"]
const _hoisted_5 = { class: "d-block mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
      _createElementVNode("div", { class: "card-body p-4 text-center" }, [
        _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
          _createTextVNode(""),
          _createElementVNode("code", {
            class: "language-markup",
            id: "basicAlertsCode"
          }, "\n<i data-feather=\"circle\"></i>\n"),
          _createTextVNode("\n")
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-lg-2 col-sm-6 col-md-3",
          key: icon.name
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("i", {
                "data-feather": icon.name
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(icon.label), 1)
            ])
          ])
        ]))
      }), 128))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-lg-12 text-center mb-4" }, [
      _createElementVNode("a", {
        href: "https://feathericons.com/",
        target: "_blank",
        class: "btn btn-primary py-2 px-4 text-decoration-none rounded-pill"
      }, [
        _createElementVNode("span", { class: "d-inline-block py-1" }, "View All Icons")
      ])
    ], -1))
  ], 64))
}